<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2">
<h2 id="pgepubid00014">CHAPTER VII</h2>
</div>
<h3 class="calibre1 sigil_not_in_toc" id="pgepubid00015">A CALL ON MR. MAITLAND</h3>
<p class="pindent"><span>O</span>UTWARDLY, John Bennett accepted his son’s new life
as a very natural development which might be expected
in a young man. Inwardly he was uneasy, fearful. Ray was
his only son; the pride of his life, though this he never showed.
None knew better than John Bennett the snares that await
the feet of independent youth in a great city. Worst of all,
for his peace of mind, he knew Ray.</p>
<p class="pindent">Ella did not discuss the matter with her father, but she
guessed his trouble and made up her mind as to what action
she would take.</p>
<p class="pindent">The Sunday before, Ray had complained bitterly about the
new cut to his salary. He had been desperate and had talked
wildly of throwing up his work and finding a new place. And
that possibility filled Ella with dismay. The Bennetts lived
frugally on a very limited income. Apparently her father had
few resources, though he always gave her the impression that
from one of these he received a fairly comfortable income.</p>
<p class="pindent">The cottage was Bennett’s own property, and the cost of
living was ridiculously cheap. A woman from the village
came in every morning to do heavy work, and once a week to
assist with the wash. That was the only luxury which her
father’s meagre allowance provided for. So that she faced the
prospect of an out-of-work Ray with alarm and decided upon
her line of action.</p>
<p class="pindent">One morning Johnson, crossing the marble floor of Maitland’s
main office, saw a delicious figure come through the
swing doors, and almost ran to meet it.</p>
<p class="pindent">“My dear Miss Bennett, this is a wonderful surprise—Ray
is out, but if you’ll wait——”</p>
<p class="pindent">“I’m glad he is out,” she said, relieved. “I want to see
Mr. Maitland. Is it possible?”</p>
<p class="pindent">The cheery face of the philosopher clouded.</p>
<p class="pindent">“I’m afraid that will be difficult,” he said. “The old man
never sees people—even the biggest men in the City. He hates
women and strangers, and although I’ve been with him all
these years, I’m not so sure that he has got used to me!
What is it about?”</p>
<p class="pindent">She hesitated.</p>
<p class="pindent">“It’s about Ray’s salary,” and then, as he shook his head,
she went on urgently: “It is so important, Mr. Johnson.
Ray has extravagant tastes, and if they cut his salary it means—well,
you know Ray so well!”</p>
<p class="pindent">He nodded.</p>
<p class="pindent">“I don’t know whether I can do anything,” he said dubiously.
“I’ll go up and ask Mr. Maitland, but I’m afraid that
it is a million to one chance against his seeing you.”</p>
<p class="pindent">When he came back, the jovial face of Mr. Johnson was one
broad smile.</p>
<p class="pindent">“Come up before he changes his mind,” he said, and led
her to the lift. “You’ll have to do all the talking, Miss
Bennett—he’s an eccentric old cuss and as hard as flint.”</p>
<p class="pindent">He showed her into a small and comfortably furnished room,
and waved his hand to a writing-table littered with papers.</p>
<p class="pindent">“My little den,” he explained.</p>
<p class="pindent">From the “den” a large rosewood door opened upon Mr.
Maitland’s office.</p>
<p class="pindent">Johnson knocked softly, and, with a heart that beat a
little faster, Ella was ushered into the presence of the strange
old man who at that moment was dominating the money
market.</p>
<p class="pindent">The room was large, and the luxury of the fittings took her
breath away. The walls were of rosewood inlaid with exquisite
silver inlay. Light came from concealed lamps in the
cornice as well as from the long stained-glass windows. Each
article of furniture in the room was worth a fortune, and she
guessed that the carpet, into which her feet sank, equalled in
costliness the whole contents of an average house.</p>
<p class="pindent">Behind a vast ormolu writing-table sat the great Maitland,
bolt upright, watching her from under his shaggy white brows.
A few stray hairs of his spotless beard rested on the desk, and
as he raised his hand to sweep them into place, she saw he
wore fingerless woollen gloves. His head was completely
bald . . . she looked at his big ears, standing away from
his head, fascinated. Patriarchal, yet repulsive. There was
something gross, obscene, about him that hurt her. It was
not the untidiness of his dress, it was not his years. Age
brings refinement, that beauty of decay that the purists call
caducity. This old man had grown old coarsely.</p>
<p class="pindent">His scrutiny lacked the assurance she expected. It almost
seemed that he was nervous, ill at ease. His gaze shifted from
the girl to his secretary, and then to the rich colouring of the
windows, and then furtively back to Ella again.</p>
<p class="pindent">“This is Miss Bennett, sir. You remember that Bennett
is our exchange clerk, and a very smart fellow indeed. Miss
Bennett wants you to reconsider your decision about that salary
cut.”</p>
<p class="pindent">“You see, Mr. Maitland,” Ella broke in, “we’re not particularly
well off, and the reduction makes a whole lot of
difference to us.”</p>
<p class="pindent">Mr. Maitland wagged his bald head impatiently.</p>
<p class="pindent">“I don’t care whether you’re well off or not well off,”
he said loudly. “When I reduces salaries I reduces ’um,
see?”</p>
<p class="pindent">She stared at him in amazement. The voice was harsh
and common. The language and tone were of the gutter.
In that sentence he confirmed all her first impressions.</p>
<p class="pindent">“If he don’t like it he can go, and if you don’t like it”—he
fixed his dull eyes on the uncomfortable-looking Johnson—“you
can go too. There’s lots of fellers I can get—pick
’um up on the streets! Millions of ’um! That’s all.”
Johnson tiptoed from the presence and closed the door
behind her.</p>
<p class="pindent">“He’s a horror!” she gasped. “How can you endure
contact with him, Mr. Johnson?”</p>
<p class="pindent">The stout man smiled quietly.</p>
<p class="pindent">“ ‘Millions of ’um,’ ” he repeated, “and he’s right. With
a million and a half unemployed on the streets, I can’t throw
up a good job——”</p>
<p class="pindent">“I’m sorry,” she said, impulsively putting her hand on his
arm. “I didn’t know he was like that,” she went on more
mildly. “He’s—terrible!”</p>
<p class="pindent">“He’s a self-made man, and perhaps he would have been
well advised to have got an artisan to do the job,” smiled
Johnson, “but he’s not really bad. I wonder why he saw
you?”</p>
<p class="pindent">“Doesn’t he see people?”</p>
<p class="pindent">He shook his head.</p>
<p class="pindent">“Not unless it is absolutely necessary, and that only happens
about twice a year. I don’t think there is anybody in
this building that he’s ever spoken to—not even the managers.”</p>
<p class="pindent">He took her down to the general office. Ray had not come
back.</p>
<p class="pindent">“The truth is,” confessed Johnson when she asked him,
“that Ray hasn’t been to the office this morning. He sent
word to say that he wasn’t feeling any too good, and I fixed it
so that he has a day off.”</p>
<p class="pindent">“He’s not ill?” she asked in alarm, but Johnson reassured
her.</p>
<p class="pindent">“No. I got on the telephone to him—he has a telephone
at his new flat.”</p>
<p class="pindent">“I thought he had an ordinary apartment!” she said,
aghast, the housewife in her perturbed. “A flat—where is
it?”</p>
<p class="pindent">“In Knightsbridge,” replied Johnson quietly. “Yes, it
sounds expensive, but I believe he has a bargain. A man who
was going abroad sub-let it to him for a song. I suppose he
wrote to you from the lodgings in Bloomsbury where he
intended going. May I be candid, Miss Bennett?”</p>
<p class="pindent">“If it is about Ray, I wish you would,” she answered
quickly.</p>
<p class="pindent">“Ray is rather worrying me,” said Johnson. “Naturally
I want to do all that I can for him, for I am fond of him. At
present my job is covering up his rather frequent absences
from the office—you need not mention this fact to him—but
it is rather a strain, for the old man has an uncanny instinct
for a shirker. He is living in better style than he ought to be
able to afford, and I’ve seen him dressed to kill with some of
the swellest people in town—at least, they looked swell.”</p>
<p class="pindent">The girl felt herself go cold, and the vague unrest in her
mind became instantly a panic.</p>
<p class="pindent">“There isn’t . . . anything wrong at the office?” she
asked anxiously.</p>
<p class="pindent">“No. I took the liberty of going through his books.
They’re square. His cash account is right to a centimo.
Crudely stated, he isn’t stealing—at least, not from us.
There’s another thing. He calls himself Raymond Lester at
Knightsbridge. I found this out by accident, and asked him
why he had taken another name. His explanation was fairly
plausible. He didn’t want Mr. Bennett to hear that he was
cutting a shine. He has some profitable outside work, but
he won’t tell me what it is.”</p>
<p class="pindent">Ella was glad to get away, glad to reach the seclusion which
the wide spaces of the park afforded. She must think and
decide upon the course she would take. Ray was not the
kind of boy to accept the draconic attitude, either in her or in
John Bennett. His father must not know—she must appeal
to Ray. Perhaps it was true that he had found a remunerative
sideline. Lots of young men ran spare time work with
profit to themselves—only Ray was not a worker.</p>
<p class="pindent">She sat down on a park chair to wrestle with the problem,
and so intent was she upon its solution that she did not realize
that somebody had stopped before her.</p>
<p class="pindent">“This is a miracle!” said a laughing voice, and she looked
up into the blue eyes of Dick Gordon. “And now you can
tell me what is the difficulty?” he asked as he pulled another
chair toward her and sat down.</p>
<p class="pindent">“Difficulty . . . who . . . who said I was in difficulties?”
she countered.</p>
<p class="pindent">“Your face is the traitor,” he smiled. “Forgive this
attire. I have been to make an official call at the United
States Embassy.”</p>
<p class="pindent">She noticed for the first time that he wore the punctilious
costume of officialdom, the well-fitting tail-coat, the polished
top-hat and regulation cravat. She observed first of all that
he looked very well in them, and that he seemed even younger.</p>
<p class="pindent">“I have an idea it is your brother,” he said. “I saw him
a few minutes ago—there he is now.”</p>
<p class="pindent">She followed the direction of his eyes, and half rose from her
chair in her astonishment. Riding on the tan track which ran
parallel to the park road, were a man and a girl. The man was
Ray. He was smartly dressed, and from the toes of his
polished riding-boots to the crown of his grey hat, was all that
was creditable to expensive tailoring. The girl at his side was
young, pretty, petite.</p>
<p class="pindent">The riders passed without Ray noticing the interested spectators.
He was in his gayest mood, and the sound of his
laughter came back to the dumbfounded girl.</p>
<p class="pindent">“But . . . I don’t understand—do you know the lady,
Mr. Gordon?”</p>
<p class="pindent">“Very well by repute,” said Dick drily. “Her name is
Lola Bassano.”</p>
<p class="pindent">“Is she—a lady?”</p>
<p class="pindent">Dick’s eyes twinkled.</p>
<p class="pindent">“Elk says she’s not, but Elk is prejudiced. She has money
and education and breed. Whether or not these three assets
are sufficient to constitute a lady, I don’t know. Elk says
not, but, as I say, Elk is considerably prejudiced.”</p>
<p class="pindent">She sat silent, her mind in a whirl.</p>
<p class="pindent">“I have an idea that you want help . . . about your
brother,” said Dick quietly. “He is frightening you, isn’t
he?”</p>
<p class="pindent">She nodded.</p>
<p class="pindent">“I thought so. He is puzzling <span class="it">me</span>. I know all about him,
his salary and prospects and his queer masquerade under an
<span class="it">alias</span>. I’m not troubling about that, because boys love those
kinds of mysteries. Unfortunately, they are expensive mysteries,
and I want to know how he can afford to keep up this
suddenly acquired position.”</p>
<p class="pindent">He mentioned a sum and she gasped.</p>
<p class="pindent">“It costs all that,” said Dick. “Elk, who has a passion
for exact detail, and who knows to a penny what the riding
suit costs, supplied me with particulars.”</p>
<p class="pindent">She interrupted him with such a gesture of despair that he
felt a brute.</p>
<p class="pindent">“What can I do . . . what can I do?” she asked. “Everybody
wants to help—you, Mr. Johnson, and, I’m sure, Mr.
Elk. But he is impossible—Ray, I mean. It will be fighting
a feather bed. It may seem absurd to you, so much fuss
over Ray’s foolish escapade, but it means, oh, so much to us,
father and me!”</p>
<p class="pindent">Dick said nothing. It was too delicate a matter for an
outsider to intrude upon. But the real delicacy of the situation
was comprised in the boy’s riding companion. As
though guessing his thoughts, she asked suddenly:</p>
<p class="pindent">“Is she a nice girl—Miss Bassano? I mean, is she one
whom Ray should know?”</p>
<p class="pindent">“She is very charming,” he answered after a pause, and
she noted the evasion and carried the subject no farther.
Presently she turned the talk to her call on Ezra Maitland, and
he heard her description without expressing surprise.</p>
<p class="pindent">“He’s a rough diamond,” he said. “Elk knows something
about him which he refuses to tell. Elk enjoys mystifying
his chiefs even more than detecting criminals. But I’ve heard
about Maitland from other sources.”</p>
<p class="pindent">“Why does he wear gloves in the office?” she asked
unexpectedly.</p>
<p class="pindent">“Gloves—I didn’t know that,” he said, surprised. “Why
shouldn’t he?”</p>
<p class="pindent">She shook her head.</p>
<p class="pindent">“I don’t know . . . it was a silly idea, but I thought—it
has only occurred to me since . . .”</p>
<p class="pindent">He waited.</p>
<p class="pindent">“When he put up his hand to smooth his beard, I’m almost
sure I saw a tattoo mark on his left wrist—just the edge of it
showing above the end of the glove—the head and eyes of a
frog.”</p>
<p class="pindent">Dick Gordon listened, thunderstruck.</p>
<p class="pindent">“Are you sure it wasn’t your imagination, Miss Bennett?”
he asked. “I am afraid the Frog is getting on all our nerves.”</p>
<p class="pindent">“It may have been,” she nodded; “but I was within a
few feet of him, and a patch of light, reflected from his blotter,
caught the wrist for a second.”</p>
<p class="pindent">“Did you speak to Johnson about it?”</p>
<p class="pindent">She shook her head.</p>
<p class="pindent">“I thought afterwards that even he, with all his long years
of service, might not have observed the tattoo mark. I
remember now that Ray told me Mr. Maitland always wore
gloves, summer or winter.”</p>
<p class="pindent">Dick was puzzled. It was unlikely that this man, the head
of a great financial corporation, should be associated with a
gang of tramps. And yet——</p>
<p class="pindent">“When is your brother going to Horsham?” he asked.</p>
<p class="pindent">“On Sunday,” said the girl. “He has promised father to
come to lunch.”</p>
<p class="pindent">“I suppose,” said the cunning young man, “that it isn’t
possible to ask me to be a fourth?”</p>
<p class="pindent">“You will be a fifth,” she smiled. “Mr. Johnson is coming
down too. Poor Mr. Johnson is scared of father, and I think
the fear is mutual. Father resembles Maitland in that respect,
that he does not like strangers. I’ll invite you anyway,” she
said, and the prospect of the Sunday meeting cheered her.</p>
<p class="pindent">Elk came to see him that night, just as he was going out to
a theatre, and Dick related the girl’s suspicion. To his surprise,
Elk took the startling theory very coolly.</p>
<p class="pindent">“It’s possible,” he said, “but it’s more likely that the
tattoo mark isn’t a frog at all. Old Maitland was a seaman as
a boy—at least, that is what the only biography of him in
existence says. It’s a half-column that appeared in a London
newspaper about twelve years ago, when he bought up Lord
Meister’s place on the Embankment and began to enlarge his
offices. I’ll tell you this, Mr. Gordon, that I’m quite prepared
to believe anything of old Maitland.”</p>
<p class="pindent">“Why?” asked Dick in astonishment. He knew nothing
of the discoveries which the detective had made.</p>
<p class="pindent">“Because I just should,” said Elk. “Men who make
millions are not ordinary. If they were ordinary they
wouldn’t be millionaires. I’ll inquire about that tattoo mark.”</p>
<p class="pindent">Dick’s attention was diverted from the Frogs that week by
an unusual circumstance. On the Tuesday he was sent for
by the Foreign Minister’s secretary, and, to his surprise, he
was received personally by the august head of that department.
The reason for this signal honour was disclosed.</p>
<p class="pindent">“Captain Gordon,” said the Minister, “I am expecting
from France the draft commercial treaty that is to be signed
as between ourselves and the French and Italian Governments.
It is very important that this document should be well guarded
because—and I tell you this in confidence—it deals with a
revision of tariff rates. I won’t compromise you by telling
you in what manner the revisions are applied, but it is essential
that the King’s Messenger who is bringing the treaty should
be well guarded, and I wish to supplement the ordinary police
protection by sending you to Dover to meet him. It is a little
outside your duties, but your Intelligence work during the war
must be my excuse for saddling you with this responsibility.
Three members of the French and Italian secret police will
accompany him to Dover, when you and your men will take
on the guard duty, and remain until you personally see the
document deposited in my own safe.”</p>
<p class="pindent">Like many other important duties, this proved to be wholly
unexciting. The Messenger was picked up on the quay at
Dover, shepherded into a Pullman coupé which had been
reserved for him, and the passage-way outside the coupé
was patrolled by two men from Scotland Yard. At Victoria
a car, driven by a chauffeur-policeman and guarded by armed
men, picked up the Messenger and Dick, and drove them to
Calden Gardens. In his library the Foreign Secretary
examined the seals carefully, and then, in the presence of Dick
and the Detective-Inspector who had commanded the escort,
placed the envelope in the safe.</p>
<p class="pindent">“I don’t suppose for one moment,” said the Foreign Minister
with a smile, after all the visitors but Dick had departed,
“that our friends the Frogs are greatly interested. Yet,
curiously enough, I had them in my mind, and this was responsible
for the extraordinary precautions we have taken. There
is, I suppose, no further clue in the Genter murder?”</p>
<p class="pindent">“None, sir—so far as I know. Domestic crime isn’t really
in my department. And any kind of crime does not come to
the Public Prosecutor until the case against an accused person
is ready to be presented.”</p>
<p class="pindent">“It is a pity,” said Lord Farmley. “I could wish that the
matter of the Frogs was not entirely in the hands of Scotland
Yard. It is so out of the ordinary, and such a menace to
society, that I should feel more happy if some extra department
were controlling the investigations.”</p>
<p class="pindent">Dick Gordon might have said that he was itching to assume
that control, but he refrained. His lordship fingered his
shaven chin thoughtfully. He was an austere man of sixty,
delicately featured, as delicately wrinkled, the product of
that subtle school of diplomacy which is at once urbane and
ruthless, which slays with a bow, and is never quite so dangerous
as when it is most polite.</p>
<p class="pindent">“I will speak to the Prime Minister,” he said. “Will you
dine with me, Captain Gordon?”</p>
<p class="pindent">Early in the next afternoon, Dick Gordon was summoned to
Downing Street, and was informed that a special department
had been created to deal exclusively with this social menace.</p>
<p class="pindent">“You have <span class="it">carte blanche</span>, Captain Gordon. I may be
criticized for giving you this appointment, but I am perfectly
satisfied that I have the right man,” said the Prime Minister;
“and you may employ any officer from Scotland Yard you
wish.”</p>
<p class="pindent">“I’ll take Sergeant Elk,” said Dick promptly, and the
Prime Minister looked dubious.</p>
<p class="pindent">“That is not a very high rank,” he demurred.</p>
<p class="pindent">“He is a man with thirty years’ service,” said Dick; “and
I believe that only his failure in the educational test has stopped
his further promotion. Let me have him, sir, and give him
the temporary rank of Inspector.”</p>
<p class="pindent">The older man laughed.</p>
<p class="pindent">“Have it your own way,” he said.</p>
<p class="pindent">Sergeant Elk, lounging in to report progress that afternoon,
was greeted by a new title. For a while he was dazed, and
then a slow smile dawned on his homely face.</p>
<p class="pindent">“I’ll bet I’m the only inspector in England who doesn’t
know where Queen Elizabeth is buried!” he said, not without
pride.</p>
<div class="calibre2"><span id="Page_58" title="58"></span><div class="pg-boilerplate" id="calibre_pb_1"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?1e94a58d